import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../styles/loginPage/login.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useNavigate, useSearchParams } from "react-router-dom";
import Modal from "../modal/Modal";
import confirmIcon from "../../assets/img/iconamoon--shield-yes-fill.svg";
const ResetPasswordForm = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [searchParams] = useSearchParams();
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [generalError, setGeneralError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [hasUserEditedConfirm, setHasUserEditedConfirm] = useState(false);

  const token = searchParams.get("token");
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const isPasswordReset = searchParams.get("type") === "reset";

  useEffect(() => {
    if (!token) {
      setGeneralError(
        "Invalid or expired token. Please request a new password reset."
      );
      setTimeout(() => navigate("/login"), 5000);
    }
  }, [token, navigate]);

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setPasswordError("");
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    setHasUserEditedConfirm(true);
  };


  const generateRandomPassword = (length = 12) => {
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array)).slice(0, length);
  };

  const handlePasswordFocus = () => {
    if (!password && !hasUserEditedConfirm) {
      const randomPassword = generateRandomPassword();
      setPassword(randomPassword);
      setConfirmPassword(randomPassword);
      setPasswordError("");
      setConfirmPasswordError("");
    }
  };

  const handleGeneratePassword = () => {
    const randomPassword = generateRandomPassword();
    setPassword(randomPassword);
    setConfirmPassword(randomPassword);
    setPasswordError("");
    setConfirmPasswordError("");
  }

  const validateForm = () => {
    let isValid = true;
    setPasswordError("");
    setConfirmPasswordError("");
    setGeneralError("");

    if (!password) {
      setPasswordError("Password is required");
      isValid = false;
    } else if (password.length < 8) {
      setPasswordError("Password must be at least 8 characters");
      isValid = false;
    }

    if (!confirmPassword) {
      setConfirmPasswordError("Please confirm your password");
      isValid = false;
    } else if (password !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      isValid = false;
    }

    return isValid;
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    setTimeout(async () => {
      try {
        const endpoint = isPasswordReset ? "reset-password" : "set-password";
        const res = await axios.post(`${baseUrl}/api/users/${endpoint}`, {
          token,
          password,
        });

        if (res.status === 200) {
          setShowSuccessModal(true);
          setTimeout(() => {
            setShowSuccessModal(false);
            navigate("/login", {
              state: {
                successMessage:
                  "Password reset successful. Please login with your new password.",
              },
            });
          }, 2000);
        }
      } catch (err) {
        if (err.response?.status === 401) {
          setGeneralError(
            "Your password reset link has expired. Please request a new one."
          );
        } else if (err.response?.status === 400) {
          setGeneralError("Token and password are required. Please try again.");
        } else {
          setGeneralError(
            "An error occurred while setting your password. Please try again."
          );
        }
      } finally {
        setLoading(false);
      }
    }, 2000);
  };

  const handlePasswordToggle = () => {
    setShowPassword(!showPassword);
  };

  const handleConfirmPasswordToggle = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  return (
    <>
      <div className="login-grid-container">
        <div className="second-grid-container">
          <div className="second-grid-column">
            <div className="welcome-message">Welcome to!</div>
            <div className="logo-name title">
              <span>MonitorPro</span>
            </div>
            <div className="description">
              Track your project's journey with precision and clarity. Monitor
              Pro empowers teams to achieve goals efficiently. Stay connected,
              informed, and in control.
            </div>
          </div>
          <div className="privacy-policy">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms & Conditions</a>
          </div>
        </div>
        <div className="first-grid-container">
          <div className="logo-name">
            <span>MonitorPro</span>
          </div>
          <div className="first-grid-column">
            <div className="title">Reset Password</div>

            <div className="login-form">
              <form>
                <div className="form-group password-group">
                  <input
                    name="password"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="New Password"
                    value={password}
                    onFocus={handlePasswordFocus}
                    onChange={handlePasswordChange}
                  />
                  <span
                    className="password-toggle"
                    style={{ top: passwordError ? "35%" : "50%" }}
                    onClick={handlePasswordToggle}
                  >
                    <Icon
                      icon={
                        showPassword ? "iconoir:eye-off" : "iconoir:eye-solid"
                      }
                      width="24px"
                      height="24px"
                      color="var(--login-icon-color)"
                    />
                  </span>
                  {passwordError && (
                    <div className="error-message">{passwordError}</div>
                  )}
                </div>

                <div className="form-group password-group">
                  <input
                    name="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                  />
                  <span
                    className="password-toggle"
                    style={{ top: confirmPasswordError ? "35%" : "50%" }}
                    onClick={handleConfirmPasswordToggle}
                  >
                    <Icon
                      icon={
                        showConfirmPassword ? "iconoir:eye-off" : "iconoir:eye-solid"
                      }
                      width="24px"
                      height="24px"
                      color="var(--login-icon-color)"
                    />
                  </span>
                  {confirmPasswordError && (
                    <div className="error-message">{confirmPasswordError}</div>
                  )}
                </div>

                {generalError && (
                  <div className="error-message">{generalError}</div>
                )}
                <button
                  type="submit"
                  className={`login-btn ${loading ? "btn-disabled" : ""} `}
                  disabled={loading || passwordError || confirmPasswordError}
                  onClick={handleResetPassword}
                >
                  {loading ? (
                    <AiOutlineLoading3Quarters className="loader" />
                  ) : (
                    "Reset Password"
                  )}
                </button>
              </form>
            </div>
          </div>
          <div className="copyright">
            © {new Date().getFullYear()} - AzulPlan. All rights reserved.
          </div>
        </div>
      </div>

      {showSuccessModal && (
        <Modal
          show={showSuccessModal}
          onClose={() => setShowSuccessModal(false)}
        >
          <div className="content confirmation">
            <div className="icon-container">
              <img
                src={confirmIcon}
                alt="confirm"
                width="57"
                height="57"
                style={{ color: "#007011" }}
              />
            </div>
            <div className="text">
              Password reset successful, login with your new password.
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ResetPasswordForm;
